<template>
  <div class="results-feedback-block" @click="toggleExpand">
    <div>
      <div class="results-feedback-block-interior">
        <div v-if="position === '1'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/adpt_gold.svg" />
        </div>
        <div v-else-if="position === '2'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/adpt_silver.svg" />
        </div>
        <div v-else-if="position == '3'">
          <img class="results-feedback-block-medal" alt="" src="/images/results/adpt_bronze.svg" />
        </div>
        <div class="results-feedback-block-right">
          <b class="results-feedback-block-title">{{$t('candidate_profiles.adpt_title')}}
            <b :class="'results-feedback-block-title-top10' + getGradeColour()" v-if="top10">top 10%</b>
          </b>
          <div class="results-feedback-block-text">
            <div :class="isExpanded ? ' ' : 'results-feedback-block-text-short'">
              {{$t('candidate_profiles.adpt_text')}}
            </div>
            <div v-if="!isExpanded">
              <i class="results-feedback-block-expand">{{$t('candidate_profiles.discover_more')}}</i>
            </div>
          </div>
        </div>
        <div v-if="isExpanded">
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_up.svg" />
        </div>
        <div v-else>
          <img class="results-feedback-block-expand-icon" alt="" src="@/assets/images/icon/arrow_down.svg" />
        </div>
      </div>
      <div v-if="isExpanded">
        <div class="module-laboratory">
          <div class="module-block-title">Le mot du labo</div>
          <p class="quote"><span class="quote-icon">
            </span> Être adaptable, c’est reconnaître et <strong>accepter le changement</strong> et <strong>revoir ses méthodes</strong> de travail si
            celles-ci ne collent plus au contexte. Dans un monde en <strong>mouvement constant</strong>, c’est une compétence clé pour
            évoluer de façon <strong>sereine</strong> dans un cadre professionnel.
            <span class="quote-icon end"></span>
          </p>
        </div>
        <div class="module-advantages">
          <div class="module-block-title"> Les avantages de l’adaptabilité </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon rond-check"></i></div>
              <div class="description">Reconnaître et accepter le changement</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon target"></i></div>
              <div class="description">Saisir les opportunités</div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon flag"></i></div>
              <div class="description">Être en capacité de sortir de sa zone de confort</div>
            </div>
          </div>
        </div>
        <div class="module-advices">
          <div class="module-block-title"> Comment améliorer votre adaptabilité </div>
          <div class="list-items">
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon question-sheet"></i></div>
              <div class="description">Prendre du recul, remettre en question vos méthodes de travail et apprendre à apprécier le changement. </div>
            </div>
            <div class="item">
              <div :class="'icon-container' + getGradeColour()"><i class="yuzu-icon accurate"></i></div>
              <div class="description">Essayer d’aborder les problèmes sous d’autres angles</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['position', 'top10'],
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    getGradeColour() {
      var iconClass = " ";
      switch (this.position) {
        case '1':
          iconClass += "or-gradient";
          break;
        case '2':
          iconClass += "argent-gradient";
          break;
        case '3':
          iconClass += "bronze-gradient";
          break;
        default:
          break;
      }
      return iconClass;
    }
  }
};
</script>